import { FC, PropsWithChildren } from "react";

export const EmptyHeader: FC<PropsWithChildren> = ({ children }) => (
  <div data-component="EmptyHeader" className="flex justify-center items-center">
    <div className="w-12 h-12">
      { children }
    </div>
  </div>
);
